import React from "react";

import ViewCorporateCustomerContent from "./ViewCorporateCustomerContent";

interface IViewCorporateCustomerModal {
  isOpen: boolean;
  onClose: () => void;
  customerData: any;
}

const ViewCorporateCustomerModal: React.FC<IViewCorporateCustomerModal> = ({
  isOpen,
  onClose,
  customerData,
}) => {
  return (
    <div
      className="Modal__dialog md-modal animated slideInDown"
      role="document"
      style={{ maxWidth: "95%", width: "1200px" }}
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <ViewCorporateCustomerContent
            customerData={customerData}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewCorporateCustomerModal;
